// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/detail/buttons.scss
// module id = 89
// module chunks = 0